<navigation-blocker-layout [template]="templateRef"></navigation-blocker-layout>

<ng-template #templateRef>
    <div class="fc-referral-signup">
        <div class="fc-referral-signup-display">
            <div class="fc-referral-signup-display-info">
                <div class="fc-referral-signup-display-info-details">
                    <div class="fc-referral-signup-display-info-fc-logo">
                        <a href="{{ appInfo.link }}" class="">
                            <img src="{{ appInfo.logo.signup }}" alt="{{ appInfo.name }}" />
                        </a>
                    </div>
                    <p class="fc-referral-signup-display-info-welcome" *fcMediaWrapper="'desktop'">
                        {{ 'SIGNUP.FORM.WELCOME' | translate }}
                    </p>
                    <ng-container *ngIf="displayReferralBrandInfo$ | async; else highlights">
                        <div class="fc-referral-signup-display-info-brand-wrapper" *fcMediaWrapper="'desktop'">
                            <div class="fc-referral-signup-display-info-brand-text">
                                {{ 'SIGNUP.REFERRAL.INVITEE' | translate }}
                            </div>
                            <div class="fc-referral-signup-display-info-brand-logo">
                                <img
                                    class="fc-referral-signup-display-info-brand-logo-image"
                                    src="{{ referralBrandLogoUrl$ | async }}"
                                />
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #highlights>
                        <ul class="fc-referral-signup-display-info-highlights-list" *fcMediaWrapper="'desktop'">
                            <li>
                                <fcp-icon [icon]="['fal', 'check']"></fcp-icon>
                                {{ 'SIGNUP.REQUEST.HIGHLIGHT1' | translate }}
                            </li>
                            <li>
                                <fcp-icon [icon]="['fal', 'check']"></fcp-icon>
                                {{ 'SIGNUP.REQUEST.HIGHLIGHT2' | translate }}
                            </li>
                            <li>
                                <fcp-icon [icon]="['fal', 'check']"></fcp-icon>
                                {{ 'SIGNUP.REQUEST.HIGHLIGHT3' | translate }}
                            </li>
                        </ul>
                    </ng-template>
                </div>
                <div class="fc-referral-signup-display-language" [formGroup]="languageForm">
                    <fcp-dropdown [items]="languages" formControlName="lang" [title]="languageForm.value.lang?.label">
                        <fcp-icon [icon]="['fal', 'globe']"></fcp-icon>
                    </fcp-dropdown>
                </div>
            </div>
        </div>
        <div class="fc-referral-signup-interactive">
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-template>
